import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeOptions, InterviewTypeOptions, PreInterviewResultOptions, TermFilter } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/student-pre-interviews/StudentPreInterviewsAction";
import { useStudentPreInterviewsUIContext } from "../StudentPreInterviewsUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, date, dateEnd, trackingDate, trackingDateEnd, personnelId, interviewType, parentName, studentName, studentGrade, result } = values;
  const newQueryParams = { ...queryParams };
  const filter = { date, dateEnd, trackingDate, trackingDateEnd, personnelId, interviewType, parentName, studentName, studentGrade, result };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function StudentPreInterviewsFilter() {
  // Student PreInterviews UI Context
  const preInterviewsUIContext = useStudentPreInterviewsUIContext();
  const preInterviewsUIProps = useMemo(() => {
    return {
      setQueryParams: preInterviewsUIContext.setQueryParams,
      queryParams: preInterviewsUIContext.queryParams,
    };
  }, [preInterviewsUIContext]);
  
  const dispatch = useDispatch();
  const { currentActiveTerm, personnels } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      personnels: state.studentPreInterviews.personnels
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getPersonnels(currentActiveTerm));
  }, [currentActiveTerm, dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(preInterviewsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, preInterviewsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      preInterviewsUIProps.setQueryParams(newQueryParams);
    }
  };

 const gradeOptions = FilterOptions.concat(GradeOptions);
 const personnelOptions = FilterOptions.concat(personnels);
 const resultOptions = FilterOptions.concat(PreInterviewResultOptions);
 const interviewTypeOptions = FilterOptions.concat(InterviewTypeOptions);

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        date: "",
        parentName: "",
        studentName: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            onChange={e => dispatch(actions.getPersonnels(e.target.value))}
            values={values}
          />
          <div className="form-group row">
            <div className="col-sm-2"></div>
            <label className="form-label col-form-label col-sm-2">
              Görüşme Tarihi
            </label>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="date"
                placeholder="Başlangıç"
                onBlur={handleBlur}
                value={values.date}
                onChange={(e) => {
                  setFieldValue("date", e.target.value);
                  handleSubmit();
                }}
              />
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="dateEnd"
                placeholder="Bitiş"
                onBlur={handleBlur}
                value={values.dateEnd}
                onChange={(e) => {
                  setFieldValue("dateEnd", e.target.value);
                  handleSubmit();
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-sm-2"></div>
            <label className="form-label col-form-label col-sm-2">
              Takip Tarihi
            </label>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="trackingDate"
                placeholder="Başlangıç"
                onBlur={handleBlur}
                value={values.trackingDate}
                onChange={(e) => {
                  setFieldValue("trackingDate", e.target.value);
                  handleSubmit();
                }}
              />
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="trackingDateEnd"
                placeholder="Bitiş"
                onBlur={handleBlur}
                value={values.trackingDateEnd}
                onChange={(e) => {
                  setFieldValue("trackingDateEnd", e.target.value);
                  handleSubmit();
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect
                options={personnelOptions}
                value={values.personnelId}
                placeholder="Personel"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("personnelId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Personel</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={interviewTypeOptions}
                value={values.interviewType}
                placeholder="Görüşme Türü"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("interviewType", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Görüşme Türü</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="parentName"
                placeholder="Veli Adı Soyadı"
                onBlur={handleBlur}
                value={values.parentName}
                onChange={(e) => {
                  setFieldValue("parentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Veli Adı Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentName"
                placeholder="Öğrenci Adı Soyadı"
                onBlur={handleBlur}
                value={values.studentName}
                onChange={(e) => {
                  setFieldValue("studentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Adı Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.studentGrade}
                placeholder="Sınıfı"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("studentGrade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıfı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={resultOptions}
                value={values.result}
                placeholder="Durum"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("result", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Durum</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}